import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  fill: "none",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF5100",
      d: "M18 4.047c7.705 0 13.951 6.246 13.951 13.951S25.705 31.949 18 31.949 4.049 25.703 4.049 17.998 10.295 4.047 18 4.047m.001 1.742c-6.741 0-12.206 5.465-12.206 12.206S11.26 30.201 18 30.201s12.206-5.465 12.206-12.206S24.742 5.79 18.001 5.79m5.96 7.755a.78.78 0 0 1 1.103 1.101l-8.811 8.811a.78.78 0 0 1-1.102 0l-4.405-4.405a.78.78 0 0 1 1.102-1.102l3.854 3.855z"
    }, null, -1)
  ]))]))
}
export default { render: render }